import { memo } from 'react';

import type { RelevancyCardProps } from '../DynamicCardComponent';
import { useRelevancyOptions } from '../store';

import SandEComponent from './SandEComponent';

import { competitionUrl } from '@utilities/WindowContext';

const fallbackImg = `${window.imgBaseUrl}/imgml/uefacom/performancezone/pfzcardbg.png`;

const trackingData = {
  category: 'sponsored card',
  name: 'Player ranking',
};

const BarometerComponent = (props: RelevancyCardProps) => {
  const { options } = useRelevancyOptions();

  return (
    <SandEComponent
      {...props}
      cardType='performancezone'
      fallbackImg={fallbackImg}
      logoByLanguage={options.competitionCode.toUpperCase() !== 'EURO'}
      url={`/${competitionUrl}/performancezone/`}
      buttonTag='fpz_button'
      trackingData={trackingData}
    />
  );
};

export default memo(BarometerComponent);
